<div class="container">
    <div class="title">
        {{ isEditing ? ('device.dialog.title.edit' | translate) : ('device.dialog.title.create' | translate) }}
    </div>
    <div class="content-container">
        <div class="input-container">
            <div class="input-title">
                {{ 'device.dialog.name.title' | translate }}
            </div>
            <app-channel-text-input
                name="name"
                label="device.dialog.name.label"
                [value]="deviceName"
                (onInputChange)="onNameChange($event)"
                (onFocusChange)="onNameChange($event)"
                [inputError]="validationErrors?.name"></app-channel-text-input>
        </div>
    </div>
    <div class="footer">
        <div class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="text-button save-button" (click)="save()" [class.save-disable]="isSaveDisabled()">
            {{ isEditing ? ('device.dialog.edit' | translate) : ('device.dialog.create' | translate) }}
        </div>
    </div>
</div>
